<div>
  <app-dynamic-form *ngIf="questions$!=null" [questions]="questions$ | async"></app-dynamic-form>
</div>
